import { GET, POST_JSON, DELETE } from '../utils/axios';
import { API_PREFIXES } from './config';
import { CreateTargetRequest, RevokeRequest } from '../types/firmware';

const FIRMWARE = `${API_PREFIXES.ADMIN}/firmware`;

// 固件接口的成功码：列表/晋升/撤销/吊销是 200，创建 Target 和创建密钥是 201。
// 现有页面只判断 0/200，照抄会让创建操作永远走失败分支。
export const isFirmwareOk = (code?: number) => code === 0 || code === 200 || code === 201;

// --- Firmware Targets ---
// GET /admin/firmware/targets
export const getFirmwareTargets = () => {
  return GET(`${FIRMWARE}/targets`, {});
};
// POST /admin/firmware/targets
export const createFirmwareTarget = (data: CreateTargetRequest) => {
  return POST_JSON(`${FIRMWARE}/targets`, data);
};

// --- Firmware Releases ---
// GET /admin/firmware/releases
export const getFirmwareReleases = () => {
  return GET(`${FIRMWARE}/releases`, {});
};
// GET /admin/firmware/releases/{id}
export const getFirmwareRelease = (id: string) => {
  return GET(`${FIRMWARE}/releases/${id}`, {});
};
// POST /admin/firmware/releases/{id}/revoke
export const revokeFirmwareRelease = (id: string, data: RevokeRequest) => {
  return POST_JSON(`${FIRMWARE}/releases/${id}/revoke`, data);
};

// --- Firmware Channels ---
// GET /admin/firmware/channels
export const getFirmwareChannels = () => {
  return GET(`${FIRMWARE}/channels`, {});
};
// GET /admin/firmware/channels/{channel}/history
// target 是可选的机型过滤（形如 "OFP/31"）。省略则返回该通道所有机型的记录——
// 一次晋升会给每个机型各写一条，不过滤时它们会混排在一起。
export const getFirmwareChannelHistory = (channel: string, target?: string) => {
  return GET(`${FIRMWARE}/channels/${channel}/history`, target ? { target } : {});
};
// POST /admin/firmware/channels/{channel}/release
export const promoteFirmwareRelease = (channel: string, releaseId: string) => {
  return POST_JSON(`${FIRMWARE}/channels/${channel}/release`, { release_id: releaseId });
};

// --- Firmware Publisher Keys ---
// GET /admin/firmware/publisher-keys
export const getPublisherKeys = () => {
  return GET(`${FIRMWARE}/publisher-keys`, {});
};
// POST /admin/firmware/publisher-keys
export const createPublisherKey = (data: { name: string }) => {
  return POST_JSON(`${FIRMWARE}/publisher-keys`, data);
};
// DELETE /admin/firmware/publisher-keys/{id}
export const revokePublisherKey = (id: string) => {
  return DELETE(`${FIRMWARE}/publisher-keys/${id}`, {});
};
